<template>
  <div class="counter" :class="[theme, isActive]">
    <img
      :src="require(`@/${option.image}`)"
      height="42"
      width="42"
      class="counter__image counter__image--sm"
    >
    <span class="counter__title">
      {{ option.choice }}
    </span>
    <img
      :src="require(`@/${option.image}`)"
      height="96"
      width="96"
      class="counter__image counter__image--md"
    >
    <div><slot /></div>
    <div class="counter__input_container">
      <span
        class="counter__icon"
        :class="{ 'counter__icon--hidden': result < 1 }"
        @click="sub"
      >
        -
      </span>
      <input
        v-model.number="result"
        type="number"
        class="counter__input"
        :class="{ 'counter__input--zero': result === 0 }"
        min="0"
        @keyup="emitResult"
      >
      <span class="counter__icon counter__icon__plus" @click="add"> + </span>
    </div>
    <span
      v-if="isSingle"
      class="counter__unsure-link"
      @click="skipQuestion"
    >{{ skipQMessage }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ImageCounter',
  props: {
    option: {
      type: Object,
      required: true
    },
    value: {
      type: [Number, Object],
      default: 0
    },
    theme: {
      type: String,
      default: 'single'
    },
    skipQMessage: {
      type: String,
      default: 'Skip this question'
    }
  },
  data () {
    return {
      result: 0
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'isMid']),
    isSingle () {
      return this.theme === 'single'
    },
    isMultiple () {
      return this.theme === 'multiple'
    },
    isActive () {
      if (this.result > 0) return 'counter--active'
      return ''
    }
  },
  watch: {
    value (newValue) {
      this.result =
        typeof newValue.result === 'number' ? newValue.result : newValue
    }
  },
  mounted () {
    if (this.value && this.value.result) this.result = this.value.result
  },
  methods: {
    emitResult () {
      if (this.isMultiple) this.$emit('input', this.result)
      if (this.isSingle) this.$emit('input', { result: this.result })
    },
    add () {
      this.result += 1
      this.emitResult()
    },
    sub () {
      if (!this.result > 0) return
      this.result -= 1
      this.emitResult()
    },
    skipQuestion () {
      this.result = 0
      this.emitResult()
      this.$emit('autoprogress')
    }
  }
}
</script>

<style lang="scss" scoped>
.counter {
  box-sizing: border-box;
  padding: 15px 9px 15px 16px;
  transition: -webkit-transform 0.2s ease-out;

  @media (min-width: 720px) {
    max-height: 350px;
    padding: 24px 0 12px;
    min-width: unset;
  }

  &.multiple {
    max-height: 72px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-width: 288px;
    margin-bottom: 14px;

    @media (min-width: 421px) {
      min-width: 340px;
    }

    @media (min-width:1250px)  {
      &:hover {
        transform: translate3d(0, -4px, 0);
        border: 1px solid $bionic-navy !important;
        box-shadow: 0px 0px 14px 0 rgba(0, 0, 0, 0.1%);
      }

     }

    &.counter--active {
      border: 1px solid $bionic-navy;
    }

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: 720px) {
      margin-bottom: 0;
      max-height: 240px;
      flex-direction: column;
      flex-basis: 30%;
      min-width: unset;
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  &__title {
    color: #1a2d6e;
    font-size: 14px;
    letter-spacing: -0.64px;
    line-height: 16px;
    text-align: left;
    max-width: 93px;
    margin-right: auto;

     @media (min-width: 421px) {
        max-width: 200px;
     }

    @media (min-width: 720px) {
      text-align: center;
      font-size: 16px;
      letter-spacing: -0.73px;
      max-width: unset;
      margin: 0 auto;
    }
  }

  &__image {
    &--sm {
      @media (min-width: 720px) {
        display: none;
      }
    }

    &--md {
      display: none;
      @media (min-width: 720px) {
        display: inline;
      }
    }
    @media (min-width: 720px) {
      margin: 16px 0 20px;
    }
  }

  &.multiple {
    .counter__image {
      margin-right: 10px;
    }
  }

  &__input {
    box-sizing: border-box;
    height: 52px;
    width: 48px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    text-align: center;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    color: $bionic-navy;
    margin-left: 12px;
    margin-right: 12px;

    &--zero {
      color: #838383;
    }
  }
  &.single {
    .counter__image {
      height: auto;
      width: 204px;
      @media (min-width: 720px) {
        width: 240px;
      }
    }
    .counter__input {
      border: none;
      margin: 0 55px;
      @media (min-width: 720px) {
        margin: 0 65px;
      }
    }
    .counter__input_container {
      height: 56px;
      width: 100%;
      border: 1px solid #e5e5e5;
      border-radius: 6px;
      text-align: center;
      margin: 10px auto 22px;
      padding-top: 1px;
      background-color: #ffffff;

      @media (min-width: 720px) {
        margin: 0 auto 28px;
        width: 340px;
      }
    }
    .counter__icon {
      position: relative;
      top: 2px;
    }
  }

  &__icon {
    color: #1370ff;
    font-size: 28px;
    letter-spacing: 0;
    line-height: 35px;
    text-align: center;
    cursor: pointer;

    // Stop icon being selected
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */

    &--hidden {
      color: #e5e5e5;
    }
  }

  &__unsure-link {
    cursor: pointer;
    color: $question-subtitle-color;
    font-size: 14px;
    letter-spacing: -0.56px;
    line-height: 20px;
    text-decoration: underline;
    margin-right: auto;

    @media (min-width: 720px) {
      margin: 0 auto;
    }
  }
}
  .single.counter--active .counter__input_container {
      border: 1px solid $bionic-navy;
  }

</style>
